
export default function Services() {
  const services = [
    {
      category: 'Maintenance',
      icon: 'ri-plant-line',
      color: 'green',
      items: [
        { name: 'Lawn Mowing & Edging', icon: 'ri-scissors-cut-line' },
        { name: 'Fertilizing & Weed Control', icon: 'ri-leaf-line' },
        { name: 'Mulching & Planting', icon: 'ri-seedling-line' },
        { name: 'Tree & Shrub Care', icon: 'ri-tree-line' },
      ],
    },
    {
      category: 'Construction',
      icon: 'ri-hammer-line',
      color: 'yellow',
      items: [
        { name: 'Garden Design', icon: 'ri-paint-brush-line' },
        { name: 'Hardscaping & Patios', icon: 'ri-building-line' },
        { name: 'Retaining Walls', icon: 'ri-layout-masonry-line' },
        { name: 'Irrigation Systems', icon: 'ri-drop-line' },
      ],
    },
    {
      category: 'Snow & Winter',
      icon: 'ri-snowy-line',
      color: 'cyan',
      items: [
        { name: 'Snow Plowing', icon: 'ri-truck-line' },
        { name: 'Snow Blowing', icon: 'ri-windy-line' },
        { name: 'Walkway Clearing', icon: 'ri-footprint-line' },
        { name: 'De-icing & Salting', icon: 'ri-flask-line' },
      ],
    },
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-yellow-50 text-yellow-700 rounded-full text-sm font-semibold mb-4">
            Our Services
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Complete Property Care Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From spring cleanup to winter snow removal, we handle everything your property needs throughout the year
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden transform hover:-translate-y-2"
            >
              {/* Header */}
              <div
                className={`p-8 ${
                  service.color === 'green'
                    ? 'bg-gradient-to-br from-green-500 to-green-600'
                    : service.color === 'yellow'
                    ? 'bg-gradient-to-br from-yellow-400 to-yellow-500'
                    : 'bg-gradient-to-br from-cyan-400 to-cyan-500'
                }`}
              >
                <div className="w-16 h-16 flex items-center justify-center bg-white rounded-xl mb-4">
                  <i className={`${service.icon} text-4xl ${
                    service.color === 'green'
                      ? 'text-green-600'
                      : service.color === 'yellow'
                      ? 'text-yellow-600'
                      : 'text-cyan-600'
                  }`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white">{service.category}</h3>
              </div>

              {/* Services List */}
              <div className="p-8">
                <ul className="space-y-4">
                  {service.items.map((item, itemIdx) => (
                    <li key={itemIdx} className="flex items-start space-x-3">
                      <div className={`w-8 h-8 flex items-center justify-center rounded-lg flex-shrink-0 ${
                        service.color === 'green'
                          ? 'bg-green-50'
                          : service.color === 'yellow'
                          ? 'bg-yellow-50'
                          : 'bg-cyan-50'
                      }`}>
                        <i className={`${item.icon} text-lg ${
                          service.color === 'green'
                            ? 'text-green-600'
                            : service.color === 'yellow'
                            ? 'text-yellow-600'
                            : 'text-cyan-600'
                        }`}></i>
                      </div>
                      <span className="text-gray-700 font-medium flex-1">{item.name}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-600 mb-6">
            All services included in our monthly plans – no extra charges!
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('pricing');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-4 bg-gradient-to-r from-yellow-400 to-yellow-500 text-gray-900 text-lg font-bold rounded-lg hover:from-yellow-500 hover:to-yellow-600 transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            View Pricing Plans
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
